// extracted by mini-css-extract-plugin
export default {"wrapper":"IhBe0y"};